export enum EApplicationsActionType {
  LOAD_APPLICATIONS = 'APPLICATIONS/LOAD',
  LOADING_APPLICATIONS = 'APPLICATIONS/LOADING',
  SET_APPLICATIONS = 'APPLICATIONS/SET',
}
